import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import Table from 'components/Table';
import {cancelRequest} from 'utilities/Request';
import {fetchTable, fetchEndOfDrill} from 'state/card/cardService';
import Busy from 'components/activity/Busy';
import {
  selectIsEmbed,
  selectIsPublic,
} from 'state/environment/environmentSelectors';
import OrientationScale from 'components/OrientationScale';
import FillScale from 'components/FillScale';
import './ChartTable.css';
import {selectIsFeatureEnabled} from 'state/feature/featureSelectors';
import {FEATURE_SWITCHES} from 'components/FeatureSwitch';

class ChartTable extends React.Component {
  state = {
    table: null,
  };

  componentDidMount() {
    this.fetch(this.props);
  }

  componentWillUnmount() {
    this.cancelFetch();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      cardId,
      filters,
      dateRangeFilter,
      dateTimeElement,
      filterGroupIds,
      dataControlFilters,
    } = nextProps;
    if (
      this.props.cardId !== cardId ||
      this.props.filters !== filters ||
      this.props.dateRangeFilter !== dateRangeFilter ||
      this.props.dateTimeElement !== dateTimeElement ||
      this.props.filterGroupIds !== filterGroupIds ||
      this.props.dataControlFilters !== dataControlFilters
    ) {
      this.fetch(nextProps);
    }
  }

  cancelFetch() {
    cancelRequest(this.request);
  }

  fetch({
    cardId,
    filters,
    dateTimeElement,
    dateRangeFilter,
    filterGroupIds,
    requestTable,
    dataControlFilters,
    isAddFilterTypeEnabled,
  }) {
    this.cancelFetch();
    this.request = requestTable(cardId, {
      filters,
      dateTimeElement,
      dateRangeFilter,
      dataControlContext: {filterGroupIds, filters: dataControlFilters},
      isAddFilterTypeEnabled,
      formatData: true,
    });

    this.setState({
      table: null,
    });

    this.request.then(
      (response) => {
        this.setState({
          table: response,
        });
      },
      (e) => {
        if (e.statusText === 'abort') return;
        this.setState({
          table: null,
        });
      }
    );
  }

  numberOfColumns = () =>
    this.state.table ? this.state.table.data.numColumns : 0;

  numberOfRows = () => (this.state.table ? this.state.table.data.numRows : 0);

  getHeaderAt = (column) =>
    this.state.table ? this.state.table.columns[column].displayName : null;

  getCellAt = (row, column) =>
    this.state.table ? this.state.table.data.rows[row][column] : null;

  render() {
    const {isEmbed, isPublic} = this.props;
    const TableScale = isEmbed || isPublic ? FillScale : OrientationScale;
    return (
      <TableScale>
        {(width, height, hasComputed) => (
          <Busy isLoading={!this.state.table}>
            <div
              className="ChartTable"
              style={{height: hasComputed ? height : '100vh'}}
            >
              <Table
                numberOfColumns={this.numberOfColumns}
                numberOfRows={this.numberOfRows}
                getHeaderAt={this.getHeaderAt}
                getCellAt={this.getCellAt}
              />
            </div>
          </Busy>
        )}
      </TableScale>
    );
  }
}

ChartTable.propTypes = {
  cardId: PropTypes.string.isRequired,
  filters: PropTypes.array.isRequired,
  filterGroupIds: PropTypes.array.isRequired,
  dateTimeElement: PropTypes.string,
  dateRangeFilter: PropTypes.object,
  requestTable: PropTypes.func.isRequired,
};

ChartTable.defaultProps = {
  requestTable: fetchTable,
};

export const ChartEndOfDrillTable = (props) => (
  <ChartTable {...props} requestTable={fetchEndOfDrill} />
);

export default connect((state) => ({
  isEmbed: selectIsEmbed(state),
  isPublic: selectIsPublic(state),
  isAddFilterTypeEnabled: selectIsFeatureEnabled(
    state,
    FEATURE_SWITCHES.ADD_FILTER_TYPE
  ),
}))(ChartTable);
